export enum Tips {
    POLYGONAL_GEOFENCE_CREATION_UNDO_BUTTON = 'POLYGONAL_GEOFENCE_CREATION_UNDO_BUTTON',
}
